import './style.scss';
import SettingButton from './SettingButton';
import React from 'react';
import Toggle from 'react-toggle';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, label } from 'react-bootstrap';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class MembersMentor extends React.Component {
  render() {
    let { membersStore, member, items } = this.props;
    let { confirm } = membersStore;
    return (
      <Row>
        <Col sm={6}>
          {items === 'bRoles' &&
          membersStore.getBoard(member.id).includes('board_of_director') ? (
            <div className="toggle-container">
              {membersStore.canManage || member.subdirector ? (
                <label>
                  <h5>
                    {this.props.intl.formatMessage({ id: 'director' })}
                    &nbsp;&nbsp;
                  </h5>
                </label>
              ) : null}
              {!membersStore.canManage ? null : (
                <Toggle
                  checked={member.subdirector}
                  onChange={e => {
                    if (confirm())
                      membersStore.handleDirector(
                        member.id,
                        !member.subdirector
                      );
                  }}
                />
              )}
            </div>
          ) : null}
        </Col>
        <Col sm={6}>
          <div className="role-container">
            <h5>{this.props.intl.formatMessage({ id: 'board' })}: </h5>
            <h5>
              {membersStore.getBoard(member.id).map(
                elem =>
                  `${this.props.intl.formatMessage({
                    id: elem
                  })}, `
              )}
            </h5>
            &nbsp;&nbsp;
            {!membersStore.canManage ? null : (
              <div id="setting-button-container">
                <SettingButton
                  options="bRoles"
                  member={member}
                  handle={membersStore.handleBoard}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}
